module.exports = __webpack_public_path__ + "img/case-spot.45e2ec0a.png";